import { render, staticRenderFns } from "./fundoscopy2.vue?vue&type=template&id=4a9838fe&scoped=true&"
import script from "./fundoscopy2.vue?vue&type=script&lang=js&"
export * from "./fundoscopy2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9838fe",
  null
  
)

export default component.exports